import { Box, Button, COLOR_PALETTE, Flex, Text, Title } from '@inflearn/ds-react-next';
import { dayjs, useLang } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import type { CheckPhoneVerificationCodeResponse } from '../../../../../../resources/@types/accountSchema';
import { LOGIN_METHOD_ICONS } from '../../../../../constants/icons';
import { AUTH_URL } from '../../../../../constants/urls';

export function AccountInformationByID({
  accounts,
}: {
  accounts: CheckPhoneVerificationCodeResponse[];
}) {
  const { t } = useTranslation();

  return (
    <Box w="100%" component="section">
      <Flex direction="column" justify="center" align="center" mb={24} gap={4}>
        <Title order={2}>{t('아이디(이메일) 찾기')}</Title>
        <Text ta="center">{t('인증한 휴대폰 번호로 가입된 계정입니다.')}</Text>
      </Flex>
      <Box
        p={20}
        css={{
          borderRadius: 8,
          border: `1px solid ${COLOR_PALETTE.gray[3]}`,
        }}
      >
        <Title order={5} mb={16}>
          {t('아이디(이메일) 정보')}
        </Title>
        <Flex gap={16} direction="column">
          {accounts.map(transformAccountData).map((item) => (
            <AccountItem {...item} key={item.email} />
          ))}
        </Flex>
      </Box>
      <Button component={Link} href={AUTH_URL.SIGNIN({})} size="md" mt={32} fullWidth>
        {t('로그인')}
      </Button>
    </Box>
  );
}

function transformAccountData(account: CheckPhoneVerificationCodeResponse): AccountItemProps {
  return {
    social: account.providers.map((item) => item.toLowerCase()),
    email: account.email,
    lastLogin: account.accessedAtUTC,
  };
}

type AccountItemProps = {
  social: string[];
  email: string;
  lastLogin: string;
};

function AccountItem({ social, email, lastLogin }: AccountItemProps) {
  const { t } = useTranslation();
  const { isKo } = useLang();

  return (
    <Box>
      <Flex gap={8}>{social.map((name) => LOGIN_METHOD_ICONS.get(name) || '')}</Flex>
      <Text mt={8} c="gray.9">
        {masking(email, 3, 5)}
      </Text>
      <Text c="gray.5">
        {`${dayjs(lastLogin).format(isKo ? 'YYYY. MM.' : 'MM/YYYY')} ${t('마지막 접속')}`}
      </Text>
    </Box>
  );
}

function masking(str: string, start: number, end: number) {
  return str.slice(0, start) + '*'.repeat(end - start) + str.slice(end);
}
